export const validateAlumniNewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "photo",
    "idNumber",
    "addrHome",
    "phone",
    "email",
    "programme",
    "studentNo",
    "gradYear",
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });
  if (form.cardType === "borrower" && form.afcardOwned) {
    const afcardFields = ["afcard", "afcardCopy", "afcardValid"];
    afcardFields.forEach((field) => {
      if (!form[field] || form[field].trim() === "") {
        errors.push(field);
      }
    });
  }

  return errors;
};

export const validateAlumniRenewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "idNumber",
    "addrHome",
    "phone",
    "email",
  ];
  if (form.cardType === "borrower") {
    requiredFields.push(...["photo"]);
  }
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });
  if (form.cardType === "borrower" && form.afcardOwned) {
    const afcardFields = ["afcard", "afcardCopy", "afcardValid"];
    afcardFields.forEach((field) => {
      if (!form[field] || form[field].trim() === "") {
        errors.push(field);
      }
    });
  }

  return errors;
};

export const validateAlumniReplForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = ["surname", "otherNames", "email"];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateTeacherNewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "photo",
    "idNumber",
    "addrHome",
    "phone",
    "email",
    "schoolName",
    "schoolPosition",
    "schoolProof",
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateTeacherRenewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "idNumber",
    "addrHome",
    "phone",
    "email",
    "schoolName",
    "schoolPosition",
    "schoolProof",
  ];
  if (form.cardType === "borrower") {
    requiredFields.push(...["photo"]);
  }
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateTeacherReplForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = ["surname", "otherNames", "email"];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateIndividualNewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "photo",
    "idNumber",
    "addrHome",
    "phone",
    "email",
    "institute",
    "position",
    "recommLetter",
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateIndividualRenewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "idNumber",
    "addrHome",
    "phone",
    "email",
    "institute",
    "position",
    "recommLetter",
  ];
  if (form.cardType === "borrower") {
    requiredFields.push(...["photo"]);
  }
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateIndividualReplForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = ["surname", "otherNames", "email"];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateOrganisationNewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "org",
    "orgChi",
    "orgPosition",
    "addrContact",
    "phone",
    "email",
    "orgProof"
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateOrganisationRenewForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (
    form.cardType === "borrower" &&
    ["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1
  ) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "surname",
    "otherNames",
    "chineseName",
    "org",
    "orgChi",
    "orgPosition",
    "addrContact",
    "phone",
    "email",
    "orgProof",
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateOrganisationReplForm = (form) => {
  const errors = [];
  if (["borrower", "reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = ["org", "email"];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateSchoolNewForm = (form) => {
  const errors = [];
  if (["reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = [
    "psName",
    "psNameChi",
    "psPrincipalSurname",
    "psPrincipalOtherNames",
    "psPrincipalChiName",
    "psAddr",
    "phone",
    "email",
    "psProof"
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateSchoolRenewForm = (form) => {
  const errors = [];
  if (["reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  const requiredFields = [
    "psName",
    "psNameChi",
    "psPrincipalSurname",
    "psPrincipalOtherNames",
    "psPrincipalChiName",
    "psAddr",
    "phone",
    "email",
    "psProof"
  ];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};

export const validateSchoolReplForm = (form) => {
  const errors = [];
  if (["reader"].indexOf(form.cardType) <= -1) {
    errors.push("cardType");
  }
  if (["mmw", "tkosc"].indexOf(form.pickupLocation) <= -1) {
    errors.push("pickupLocation");
  }
  const requiredFields = ["psName", "email"];
  requiredFields.forEach((field) => {
    if (!form[field] || form[field].trim() === "") {
      errors.push(field);
    }
  });

  return errors;
};